import styled from 'styled-components';
import { Palette } from 'core/config';
import { CardFooter } from 'view/components/common';

export const Row = styled.div`
    display: flex;
    padding-left: 60px;
    padding-right: 60px;
`;

export const HiddenInput = styled.input`
    display: none;
`;

export const DocumentImage = styled.img<{solid?: boolean}>`
    opacity: ${({ solid }) => solid ? '1' : '0.5'};
`;

export const DocumentPreview = styled.div<{ selectView: boolean; }>`
    background-color: rgba(252, 250, 242, 0.59);
    width: 100%;
    border-radius: 11px;
    margin-bottom: 24px;
    position: relative;

    ${({ selectView }) => selectView && `
        &:hover {
            cursor: pointer;
        }
    `}
`;

export const Asterix = styled.span`
    color: red;
`;

export const DragAndDrop = styled.img<{ draggedOver: boolean; }>`
    width: 100px;
    cursor: pointer;
    pointer-events: none;

    ${({ draggedOver }) => draggedOver && 'opacity: 0.5;'}
`;

export const DragAndDropWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const UploadDocumentText = styled.p`
    font: normal normal 900 12px 'SofiaPro-Regular';
    margin: 2px 0;
`;

export const MutedDragAndDropText = styled(UploadDocumentText)`
    font-size: 10px;
    color: ${Palette.DOVE_GREY}};
`;

export const DocumentList = styled.div`
    max-height: 287px;
    overflow-y: scroll;
    margin-top: 9px;
    width: 70%;
    margin-left: auto;
    margin-right: auto;

    @media only screen and (max-width: 450px) {
        width: 90%;
    }
`;

export const DocumentItem = styled.div`
    background-color: ${Palette.EGGSHELL_WHITE};
    padding: 1rem;
    margin: 1.5rem 0;
    border-radius: 11px;
`;

export const DocumentItemContent = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    svg {
        width: 22px !important;
        height: 22px !important;
    }
`;

export const SpacedDocumentItemContent = styled(DocumentItemContent)`
    justify-content: space-between;
    cursor: pointer;
`;

export const DocumentItemName = styled.div<{ selected?: boolean;}>`
    overflow: hidden;
    margin-left: 22px;
    font: normal normal normal 13px 'SofiaPro-Regular';
    ${({ selected }) => selected ? 'color: black;' : `color: ${Palette.DOVE_GREY};`}
`;

export const ExpandButton = styled.button`
    padding: 0.5rem;
    border: none;
    background-color: ${Palette.ORANGE};
    color: ${Palette.WHITE};
    border-radius: 8px;
    height: 35px;
    width: 35px;
    box-sizing: border-box;
    cursor: pointer;
`;


export const AddIcon = styled.span<{rotated?: boolean}>`
    font-size: 25px;
    font-weight: bold;
    transform: translateY(-5px) ${({ rotated }) => rotated && 'rotate(45deg)'};
    display: block;
`;

export const Paragraph = styled.p<{ css? : string; }>`
    font: normal normal normal 15px 'SofiaPro-Regular';
    color: ${Palette.BLUE};
    font-weight: 100;
    line-height: 18px;
    margin-top: 15px;

    span {
        font: normal normal normal 15px 'SofiaPro-Bold';
        text-decoration: underline;
        cursor: pointer;
        padding-left: 4px;
        padding-right: 4px;
    }

    ${({ css }) => css && css}
`;

export const DocumentPageCardFooter = styled(CardFooter)`
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    margin-top: 2rem;

    @media only screen and (max-width: 450px) {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 0;
    }
`;

export const UploadCompleteWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const UploadComplete = styled.img`
    width: 90px;
`;

export const TrashIcon = styled.img<{ uploading: boolean }>`
    height: 35px;
    width: 35px;
    cursor: pointer;
    ${({ uploading }) => uploading && 'opacity: 0.5;'}
`;

export const RequiredText = styled.p`
    color: red;
    text-align: left;
    padding-left: 60px;
    padding-right: 60px;
    font: normal normal normal 15px 'SofiaPro-Regular';
    margin-top: 0;
`;
